// extracted by css-extract-rspack-plugin
export default {"image":"_2bfb3978"};